import React from 'react';

interface IconSearchProps {
    iconClasses?: string;
}

const IconSearch: React.FC<IconSearchProps> = ({ iconClasses }) => {
    return (
        <svg
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-search ${iconClasses ?? ''}`}
            aria-hidden="true"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.319 12.9075C16.7628 9.76895 16.542 5.22832 13.6569 2.34314C10.5327 -0.781048 5.46734 -0.781048 2.34315 2.34314C-0.78105 5.46734 -0.78105 10.5327 2.34315 13.6569C5.22833 16.5421 9.769 16.7628 12.9075 14.3191C12.921 14.3344 12.9351 14.3494 12.9497 14.364L17.1924 18.6066C17.5829 18.9972 18.2161 18.9972 18.6066 18.6066C18.9971 18.2161 18.9971 17.583 18.6066 17.1924L14.364 12.9498C14.3493 12.9352 14.3343 12.9211 14.319 12.9075ZM12.2426 3.75736C14.5858 6.1005 14.5858 9.89945 12.2426 12.2427C9.8995 14.5858 6.1005 14.5858 3.75736 12.2427C1.41421 9.89945 1.41421 6.1005 3.75736 3.75736C6.1005 1.41421 9.8995 1.41421 12.2426 3.75736Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default IconSearch;
